export enum ArticleStatus {
  Draft,
  Review,
  Published,
}

export enum ArticleAccessLevelType {
  Public,
  Followers,
  Connections,
}

export enum ArticlePreferenceType {
  NoPreference,
  Like,
  Dislike

}

export enum ArticleElementType {
  MainImage = 1,
  Header,
  Text,
  Image,
  Video,
  Link,
  List,
  SubLine,
  Lead,
  Quote,
  AddRestoDetails
}

export enum ArticleLanguageType {
  English,
  Indonesian,
}

export class Article {
  public id: number;
  public accessLevelName: string;
  public accessLevel: ArticleAccessLevelType = ArticleAccessLevelType.Public;
  public status: ArticleStatus = ArticleStatus.Draft;
  public authorId: number;
  public authorName: string;
  public authorImageUrl: string;
  public title: string;
  public description: string;
  public mainImage: string;
  public commentCount: number;
  public likeCount: number;
  public dislikeCount: number;
  public publishedOn: Date;
  public tags: string[];
  public articleBlocks: ArticleBlock[];
  public articlePreference: ArticlePreference;
  public accessLevelStyle: string;
  public carouselData: any;
  public language: ArticleLanguageType = ArticleLanguageType.English;
}

export class DashboardArticle {
  public id: number;
  public title: string;
  public description: string;
  public mainImage: string;
  public carouselData: any;
}

export class ArticlePreference {
  public id: number;
  public articleId: number;
  public userId: number;
  public preference: ArticlePreferenceType;
  public logDateTime: Date;
  public commentCount: number;
  public likeCount: number;
  public dislikeCount: number;
}

export class CreateArticle {
  public id: number;
  public tags: number[];
  public status: ArticleStatus = ArticleStatus.Draft;
  public articleBlocks: ArticleBlock[];
  public accessLevel: ArticleAccessLevelType = ArticleAccessLevelType.Public;
  public language: ArticleLanguageType = ArticleLanguageType.English;
}

export class ArticleFilter {
  constructor() {
    this.category = [];
    this.uploadedByUserId = [];
  }
  public searchText: string;
  public fromDate: Date;
  public toDate: Date;
  public category: number[];
  public uploadedByUserId: number[];
  public pageSize: number;
  public pageNumber: number;
  public showOnlyMyArticle: boolean = false;
  public showOnlyMyLikedArticle: boolean = false;
  public language: ArticleLanguageType = ArticleLanguageType.English;
}

export class ArticleBlock {
  public id: number;
  public articleId: number;
  public type: ArticleElementType;
  public elementId: number;
  public data: string;
  public displayOrder: number;
  public isActiveForEdit: boolean = false;
  public layout: number;
  public isInHighLightMode: boolean;
  public cloneData: string;
  public images: ArticleImage[];
  public changesImages: number[];
  public isValidData: boolean;
  public isDiscardChanges: boolean;
  public isTextWithIndentationInList: boolean;
  public imageCount: number;
  public originalImage: string;
  public restaurantType: any;
  public translatedData: string;
}

export class ArticleImage {
  public image: File;
  public extension: string;
  public imageInBytes: number[];
}

export class ArticleElement {
  public id: number;
  public name: string;
  public type: ArticleElementType;
  public displayOrder: number;
  public isActive: boolean;
}

export class CarouselData {
  public Layout: number;
  public Images: string[];
}

export class ArticleTag {
  public id: number;
  public name: string;
  public isActive: boolean;
}
